(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[945],{

/***/ 62711:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


var CustomButton = function(param) {
    var className = param.className, text = param.text, isDisable = param.isDisable, onClickhandler = param.onClickhandler;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
        className: "catalog-".concat(className, " ").concat(isDisable ? "disable" : ""),
        disabled: isDisable,
        onClick: onClickhandler,
        children: text
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CustomButton);


/***/ }),

/***/ 72651:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4111);
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5950);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);











// env
var inBrowser = "object" !== "undefined";
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE9 = UA && UA.indexOf("msie 9.0") > 0;
var Dialog = function(props) {
    var animation = (props.animationType === "enter" ? props.enterAnimation : props.leaveAnimation) || props.animation;
    var className = "rodal-dialog rodal-".concat(animation, "-").concat(props.animationType);
    var CloseButton = props.showCloseButton ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        className: "rodal-close",
        onClick: props.onClose,
        children: "Close"
    }) : null;
    var width = props.width, height = props.height, measure = props.measure, duration = props.duration, customStyles = props.customStyles;
    var style = {
        width: width + "%",
        minHeight: height + measure,
        animationDuration: duration + "ms",
        WebkitAnimationDuration: duration + "ms"
    };
    var mergedStyles = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, style, customStyles);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        style: mergedStyles,
        className: className,
        children: [
            props.children,
            CloseButton
        ]
    });
};
var _Component;
var rodal = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(rodal, _superClass);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(rodal);
    function rodal() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, rodal);
        var _this;
        _this = _super.apply(this, arguments);
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "state", {
            isShow: false,
            animationType: "leave"
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "onKeyUp", function(event) {
            if (_this.props.closeOnEsc && event.keyCode === 27) {
                _this.props.onClose();
            }
        });
        (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_assert_this_initialized_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(_this), "animationEnd", function(event) {
            if (_this.state.animationType === "leave") {
                _this.setState({
                    isShow: false
                });
            } else if (_this.props.closeOnEsc) {
                _this.el.focus();
            }
            if (event.target === _this.el) {
                var onAnimationEnd = _this.props.onAnimationEnd;
                onAnimationEnd && onAnimationEnd();
            }
        });
        return _this;
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(rodal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this.props.visible) {
                    this.enter();
                }
            }
        },
        {
            key: "componentWillReceiveProps",
            value: function componentWillReceiveProps(nextProps) {
                if (!this.props.visible && nextProps.visible) {
                    this.enter();
                } else if (this.props.visible && !nextProps.visible) {
                    this.leave();
                }
            }
        },
        {
            key: "enter",
            value: function enter() {
                this.setState({
                    isShow: true,
                    animationType: "enter"
                });
                document.getElementsByTagName("html")[0].style.overflow = "hidden";
            }
        },
        {
            key: "leave",
            value: function leave() {
                this.setState(isIE9 ? {
                    isShow: false
                } : {
                    animationType: "leave"
                });
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.getElementsByTagName("body")[0].style.overflowY = "";
                document.getElementsByTagName("html")[0].style.overflow = "";
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref = this, props = ref.props, state = ref.state;
                var onClick = props.closeMaskOnClick ? props.onClose : null;
                var mask = props.showMask ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "rodal-mask",
                    style: props.customMaskStyles,
                    onClick: onClick
                }) : null;
                var style = {
                    display: state.isShow ? "block" : "none",
                    animationDuration: props.duration + "ms",
                    WebkitAnimationDuration: props.duration + "ms"
                };
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    style: style,
                    className: "rodal rodal-fade-" + state.animationType + " " + props.className,
                    onAnimationEnd: this.animationEnd,
                    tabIndex: "-1",
                    ref: function(el) {
                        _this.el = el;
                    },
                    onKeyUp: this.onKeyUp,
                    children: [
                        mask,
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Dialog, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, props), {
                            animationType: state.animationType,
                            children: props.children
                        }))
                    ]
                });
            }
        }
    ]);
    return rodal;
}(_Component = react__WEBPACK_IMPORTED_MODULE_1__.Component);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "propTypes", {
    width: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    height: prop_types__WEBPACK_IMPORTED_MODULE_10___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
        (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string)
    ]),
    measure: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    visible: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showMask: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeOnEsc: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    closeMaskOnClick: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    showCloseButton: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().bool),
    animation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    enterAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    leaveAnimation: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    duration: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().number),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().string),
    customStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    customMaskStyles: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().object),
    onClose: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func.isRequired),
    onAnimationEnd: (prop_types__WEBPACK_IMPORTED_MODULE_10___default().func)
});
// ...
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(rodal, "defaultProps", {
    width: 100,
    height: 300,
    measure: "px",
    visible: false,
    showMask: true,
    closeOnEsc: false,
    closeMaskOnClick: true,
    showCloseButton: false,
    animation: "zoom",
    enterAnimation: "",
    leaveAnimation: "",
    duration: 300,
    className: "",
    customStyles: {},
    customMaskStyles: {}
});
/* harmony default export */ __webpack_exports__["Z"] = (rodal);


/***/ }),

/***/ 42501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MiddleBody6; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(next_router);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(25617);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/Hybrid.styles.js
var Hybrid_styles = __webpack_require__(43955);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./src/components/Common/Modal/index.jsx
var Modal = __webpack_require__(72651);
// EXTERNAL MODULE: ./src/redux/actions/cart.js
var actions_cart = __webpack_require__(66162);
// EXTERNAL MODULE: ./src/components/Common/CustomBtn/index.js
var CustomBtn = __webpack_require__(62711);
;// CONCATENATED MODULE: ./src/components/HaveSomethingInMind/index.js







var HaveSomeThingInMind = function(param) {
    var islink = param.islink, isCartView = param.isCartView, forWeb = param.forWeb, icon = param.icon;
    var router = (0,next_router.useRouter)();
    var cart = (0,es/* useSelector */.v9)(function(state) {
        return state.cartReducer;
    });
    var storeInfo = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    var dispatch = (0,es/* useDispatch */.I0)();
    var handleCart = function() {
        var temp = (0,_to_consumable_array/* default */.Z)(cart.items);
        if (temp.filter(function(item) {
            return item.item_name !== "" && item.item_quantity !== "";
        })) {
            temp.push({
                item_id: Date.now(),
                item_name: "",
                quantity: "",
                item_type: "list"
            });
            dispatch((0,actions_cart/* saveCart */.FP)({
                items: temp
            }));
        }
    };
    var onClickHandler = function() {
        if (islink) {
            handleCart();
            router.push("/".concat(storeInfo.store_info.domain.split("-")[1], "/cart"));
        } else if (isCartView) {
            handleCart();
        }
        return;
    };
    var renderForWeb = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "web-havesomethingInMind--wrapper",
            children: [
                renderForMobile(icon),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "web-havesomethingInMind--btnwrap",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomBtn/* default */.Z, {
                        className: "custom-btn",
                        text: "Create list",
                        isDisable: false,
                        onClickhandler: function() {
                            handleCart();
                        }
                    })
                })
            ]
        });
    };
    var renderForMobile = function(icon) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "havesomething-in-mind__box",
            onClick: onClickHandler,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "havesomething-in-mind",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "Have some specific thing in mind ?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                            children: [
                                "Make a list of items you need",
                                islink && /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    loading: "lazy",
                                    src: "/assets/images/arrowf.png",
                                    className: "havesomething-in-mind__arrow",
                                    alt: "forward arrow icon"
                                })
                            ]
                        })
                    ]
                }),
                icon && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "havesomething-in-mind__box-image",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        loading: "lazy",
                        src: "/assets/images/perwithscope@2x.png",
                        alt: "Have something in mind icon"
                    })
                })
            ]
        });
    };
    return forWeb ? renderForWeb() : renderForMobile(true);
};
/* harmony default export */ var HaveSomethingInMind = (HaveSomeThingInMind);

// EXTERNAL MODULE: ./src/utils/routes.js + 1 modules
var routes = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/utils/isPLPRequiredSystem.js
var isPLPRequiredSystem = __webpack_require__(86423);
;// CONCATENATED MODULE: ./src/components/CategoryPopUp/index.js










function CategoryModal(props) {
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(null), 2), themeColor = ref[0], setThemeColor = ref[1];
    var ref1 = (0,es/* useSelector */.v9)(function(state) {
        return state.catalogReducer;
    }), categories = ref1.categories, productTags = ref1.productTags;
    var storeData = (0,es/* useSelector */.v9)(function(state) {
        return state.storeReducer.store;
    });
    react.useEffect(function() {
        var ref, ref1;
        if (storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) {
            var ref2, ref3;
            setThemeColor((storeData === null || storeData === void 0 ? void 0 : storeData.premium) ? storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.theme) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.colors) === null || ref3 === void 0 ? void 0 : ref3.primary_color : "#000000");
        }
    }, [
        storeData
    ]);
    var onCategoryClick = function(category) {
        var ref;
        props.toggleModal();
        if ((0,isPLPRequiredSystem/* isPLPRequiredSystem */.q)(storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : ref.theme_class)) {
            var ref1;
            router_default().push((0,routes.getRoute)("".concat(routes.PATH.SHOP, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref1 = storeData.store_info) === null || ref1 === void 0 ? void 0 : ref1.domain), undefined, {
                shallow: true
            });
        } else {
            var ref2;
            router_default().push((0,routes.getRoute)("".concat(routes.PATH.PRODUCT, "?cid=").concat(category.id), storeData === null || storeData === void 0 ? void 0 : (ref2 = storeData.store_info) === null || ref2 === void 0 ? void 0 : ref2.domain), undefined, {
                shallow: true
            });
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* default */.Z, {
        visible: props.isVisible,
        className: "bottom-modal",
        animation: "slideUp",
        onClose: props.toggleModal,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "category-modal-wrap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "closeicon pointer",
                            onClick: props.toggleModal,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                loading: "lazy",
                                src: "/assets/images/cancel.png",
                                alt: "cancel"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "category-container",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "category-box",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                children: (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories)).map(function(item, idx) {
                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            productTags.length > 0 && productTags.length === idx && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "product-tag-item-divider"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                className: "product-tag-item pointer",
                                                style: {
                                                    color: themeColor,
                                                    border: productTags.length - 1 === idx && "none"
                                                },
                                                onClick: function() {
                                                    return onCategoryClick(item);
                                                },
                                                children: (item === null || item === void 0 ? void 0 : item.name) || "Available Items"
                                            }, "".concat(item === null || item === void 0 ? void 0 : item.id, "-tag-popup"))
                                        ]
                                    });
                                })
                            })
                        })
                    })
                ]
            }),
            !(storeData === null || storeData === void 0 ? void 0 : storeData.theme) && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "category-havesomthing",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(HaveSomethingInMind, {
                    islink: true
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/utils/conditionalForMiddlebodyRender.js
var conditionalForMiddlebodyRender = __webpack_require__(56385);
// EXTERNAL MODULE: ./node_modules/aos/dist/aos.css
var aos = __webpack_require__(28279);
// EXTERNAL MODULE: ./src/utils/constants/index.js
var constants = __webpack_require__(13886);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/DesktopDsAds.js + 1 modules
var DesktopDsAds = __webpack_require__(16490);
// EXTERNAL MODULE: ./src/components/SortingAndFiltersTab/SortingAndFiltersTab.js + 2 modules
var SortingAndFiltersTab = __webpack_require__(33636);
// EXTERNAL MODULE: ./src/redux/actions/common.js
var common = __webpack_require__(31024);
// EXTERNAL MODULE: ./src/utils/checkClientDeviceType.js
var checkClientDeviceType = __webpack_require__(13508);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 169 modules
var motion = __webpack_require__(37563);
// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody7/Components/FilterDrawer/FilterDrawer.js + 4 modules
var FilterDrawer = __webpack_require__(91612);
// EXTERNAL MODULE: ./src/hooks/useTriggerInitialFilterOptions.js
var useTriggerInitialFilterOptions = __webpack_require__(42249);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/FilterDrawerMidd6/FilterDrawerMidd6.js








function FilterDrawerMidd6(props) {
    var ref, ref1;
    var dispatch = (0,es/* useDispatch */.I0)();
    var showFilterDrawer = props.showFilterDrawer, handleShowFilterDrawer = props.handleShowFilterDrawer;
    var ref2 = (0,es/* useSelector */.v9)(function(state) {
        return {
            headerHeight: state.commonReducer.headerHeight,
            headerRef: state.commonReducer.headerRef,
            storeData: state.storeReducer.store
        };
    }), storeData = ref2.storeData, headerHeight = ref2.headerHeight, headerRef = ref2.headerRef;
    (0,useTriggerInitialFilterOptions/* default */.Z)();
    (0,react.useEffect)(function() {
        dispatch((0,common/* hideFiltersCategoryAndCollection */.Zw)(true));
        return function() {
            dispatch((0,common/* hideFiltersCategoryAndCollection */.Zw)(false));
        };
    }, []);
    (0,react.useEffect)(function() {
        if (checkClientDeviceType/* IS_MOBILE */.q$ && showFilterDrawer) {
            document.getElementsByTagName("body")[0].style.overflow = "hidden";
        } else {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        }
        return function() {
            document.getElementsByTagName("body")[0].style.overflow = "auto";
        };
    }, [
        showFilterDrawer
    ]);
    (0,react.useEffect)(function() {
        if (checkClientDeviceType/* IS_MOBILE */.q$ && headerRef.current) {
            showFilterDrawer ? headerRef.current.style.display = "none" : headerRef.current.style.display = "";
        }
    }, [
        showFilterDrawer
    ]);
    var ref3;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
        children: showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
            initial: {
                opacity: 0,
                x: checkClientDeviceType/* IS_MOBILE */.q$ ? 0 : -300,
                zIndex: -1
            },
            transition: checkClientDeviceType/* IS_MOBILE */.q$ ? {
                duration: 0.5
            } : {
                duration: 0.5
            },
            animate: {
                opacity: 1,
                x: 0,
                zIndex: checkClientDeviceType/* IS_MOBILE */.q$ ? 12 : 0
            },
            exit: {
                opacity: 0,
                x: checkClientDeviceType/* IS_MOBILE */.q$ ? 0 : -300,
                zIndex: -1
            },
            style: {
                display: "flex",
                top: checkClientDeviceType/* IS_MOBILE */.q$ ? 0 : headerHeight,
                position: checkClientDeviceType/* IS_MOBILE */.q$ ? "fixed" : "sticky",
                background: "white",
                height: "fit-content"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "filterDrawerWrapper",
                showFilterDrawer: showFilterDrawer,
                ref: props.filterDrawerWrapperRef,
                style: props.showFilterDrawer ? {
                    display: "unset"
                } : {
                    display: "none"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawer/* default */.Z, {
                        handleShowFilterDrawer: handleShowFilterDrawer,
                        hideCollectionFilter: props.hideCollectionFilter,
                        hideCategoryFilter: props.hideCategoryFilter,
                        hideTags: props.hideTags
                    }),
                    checkClientDeviceType/* IS_MOBILE */.q$ && props.showFilterDrawer && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        onClick: handleShowFilterDrawer,
                        className: "filterDrawerMobileCtaContainer",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filterDrawerMobileCta",
                                children: "Close"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "filterDrawerMobileCta",
                                style: {
                                    background: "".concat((ref3 = storeData === null || storeData === void 0 ? void 0 : (ref = storeData.theme) === null || ref === void 0 ? void 0 : (ref1 = ref.colors) === null || ref1 === void 0 ? void 0 : ref1.primary_color) !== null && ref3 !== void 0 ? ref3 : "#222"),
                                    color: "#fff"
                                },
                                children: "Apply"
                            })
                        ]
                    })
                ]
            })
        }, "filterDrawer")
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./src/components/FlatList/index.js
var FlatList = __webpack_require__(55772);
// EXTERNAL MODULE: ./src/redux/actions/catalog.js
var catalog = __webpack_require__(96031);
// EXTERNAL MODULE: ./src/redux/ssrStore.ts
var ssrStore = __webpack_require__(20155);
// EXTERNAL MODULE: ./src/utils/getFilteredOptionProducts.js
var getFilteredOptionProducts = __webpack_require__(36051);
// EXTERNAL MODULE: ./src/context/WidgetDndContext/index.ts + 6 modules
var WidgetDndContext = __webpack_require__(17502);
// EXTERNAL MODULE: ./src/components/WidgetMaker/WidgetDnD/GlobalCfeLoader.tsx
var GlobalCfeLoader = __webpack_require__(79220);
// EXTERNAL MODULE: ./src/components/DesignSystem/Widgets2.0/ProductListWrapper/index.ts
var ProductListWrapper = __webpack_require__(68464);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/FilteredAndSortItems/FilteredAndSortItems.tsx
// import LoaderIcon from '@/components/Common/LoaderIcon';















function FilteredAndSortItems() {
    var plpInitFilterCall = function plpInitFilterCall() {
        var ref;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) {
            var selectedCategory = categories.find(function(categoryItem) {
                var ref;
                return (categoryItem === null || categoryItem === void 0 ? void 0 : categoryItem.id) == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedCategory) {
                var categoryFilterObject = {};
                var categorySubFilter = [];
                var subFilter = {};
                subFilter["id"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.id;
                subFilter["name"] = selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name;
                categorySubFilter.push(subFilter);
                categoryFilterObject["sub_filters"] = categorySubFilter;
                categoryFilterObject["name"] = "Categories";
                categoryFilterObject["type"] = 2;
                dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                    categoryFilterObject
                ]));
                setInitialFilter([
                    categoryFilterObject
                ]);
                plpFilterCall(categoryFilterObject, constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
            var selectedTag = productTags.find(function(tagItem) {
                var ref;
                return (tagItem === null || tagItem === void 0 ? void 0 : tagItem.id) == (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid);
            });
            if (selectedTag) {
                var tagFilterObject = {};
                var tagSubFilter = [];
                var subFilter1 = {};
                subFilter1["id"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.id;
                subFilter1["name"] = selectedTag === null || selectedTag === void 0 ? void 0 : selectedTag.name;
                tagSubFilter.push(subFilter1);
                tagFilterObject["sub_filters"] = tagSubFilter;
                tagFilterObject["name"] = "Tags";
                tagFilterObject["type"] = 3;
                dispatch((0,catalog/* saveFilteredOptions */.Pu)([
                    tagFilterObject
                ]));
                setInitialFilter([
                    tagFilterObject
                ]);
                plpFilterCall(tagFilterObject, constants/* SORTING_TYPE.CATEGORIES */.KL.CATEGORIES);
            }
        }
    };
    var getSelectedFilters = function getSelectedFilters() {
        var ref, ref1;
        /** add previous filteroption of collection and category and PLP page */ var tempFiltersArray = (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) !== undefined || (router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.collectionId) !== undefined ? (0,_to_consumable_array/* default */.Z)(initialFilter) : [];
        !!(filteredOptions === null || filteredOptions === void 0 ? void 0 : filteredOptions.length) && filteredOptions.forEach(function(filterItem) {
            var ref;
            var tempFilterObject = {};
            var tempSubFilterArray = [];
            !!((ref = filterItem.sub_filters) === null || ref === void 0 ? void 0 : ref.length) && filterItem.sub_filters.forEach(function(subFilterItem) {
                var tempSubFilters = {};
                if (subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.is_selected) {
                    tempSubFilters["id"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.id;
                    tempSubFilters["name"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.name;
                    tempSubFilters["colour_code"] = subFilterItem === null || subFilterItem === void 0 ? void 0 : subFilterItem.colour_code;
                    tempSubFilterArray.push(tempSubFilters);
                }
            });
            if (tempSubFilterArray === null || tempSubFilterArray === void 0 ? void 0 : tempSubFilterArray.length) {
                tempFilterObject["name"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.name;
                tempFilterObject["type"] = filterItem === null || filterItem === void 0 ? void 0 : filterItem.type;
                tempFilterObject["sub_filters"] = tempSubFilterArray;
                tempFiltersArray.push(tempFilterObject);
            }
        });
        return tempFiltersArray;
    };
    var returnFilterItemsData = function returnFilterItemsData() {
        return filteredItems;
    };
    var changeinitialPlpCallToFalse = function changeinitialPlpCallToFalse(status, isNextPage) {
        if (status) {
            initialPlpCall.current = false;
            isNext.current = isNextPage;
        }
    };
    var plpFilterCall = function plpFilterCall(filterObject, sortType) {
        var payload = {
            store_id: storeData === null || storeData === void 0 ? void 0 : storeData.store_id,
            page_no: 1,
            sorting_type: sortType,
            filters: [
                filterObject
            ]
        };
        initialPlpCall.current = true;
        dispatch((0,catalog/* getFilteredItemsOptions */.OI)(payload, changeinitialPlpCallToFalse));
        dispatch((0,catalog/* filtersCounter */.Ds)(constants/* FILTER_COUNTER_OPTIONS.INC */.zO.INC));
    };
    var ref, ref1, ref2;
    var ref3 = (0,WidgetDndContext/* useWidgetDndContextData */.KX)(), globalStyle = ref3.widgetContextState.globalStyle;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref4 = (0,react.useState)(false), isFullItemsLoaded = ref4[0], setIsFullItemsLoaded = ref4[1];
    var ref5 = (0,react.useState)([]), initialFilter = ref5[0], setInitialFilter = ref5[1];
    var pageNo = (0,react.useRef)(null);
    var isNext = (0,react.useRef)(null);
    var loader = (0,react.useRef)(null);
    var initialPlpCall = (0,react.useRef)(null);
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            filteredItems: state.catalogReducer.filteredItems,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter,
            sortType: state.catalogReducer.sortType,
            filteredOptions: state.catalogReducer.filteredOptions
        };
    }), filteredItems = ref6.filteredItems, filterAppliedCounter = ref6.filterAppliedCounter, sortType = ref6.sortType, filteredOptions = ref6.filteredOptions;
    var ref7 = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        var ref, ref1;
        return {
            categories: (ref = state.catalogReducer) === null || ref === void 0 ? void 0 : ref.categories,
            productTags: (ref1 = state.catalogReducer) === null || ref1 === void 0 ? void 0 : ref1.productTags,
            storeData: state.storeReducer.store
        };
    }), categories = ref7.categories, productTags = ref7.productTags, storeData = ref7.storeData;
    (0,react.useEffect)(function() {
        var ref, ref1;
        /** if it is plp page plpinitfiltercall will call api with page no 1 */ if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) !== undefined && !sortType && filterAppliedCounter <= 1 && !(parseInt(router === null || router === void 0 ? void 0 : (ref1 = router.query) === null || ref1 === void 0 ? void 0 : ref1.cid) === -1)) {
            pageNo.current = [
                0,
                1
            ];
        } else {
            pageNo.current = [
                0
            ];
        }
        loader.current = false;
        isNext.current = true;
        dispatch((0,catalog/* resetFilterItems */.V$)());
    }, [
        filterAppliedCounter,
        sortType
    ]);
    (0,react.useEffect)(function() {
        initialPlpCall.current = false;
        plpInitFilterCall();
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid,
        categories,
        productTags
    ]);
    function loadMoreItems() {
        return _loadMoreItems.apply(this, arguments);
    }
    function _loadMoreItems() {
        _loadMoreItems = (0,_async_to_generator/* default */.Z)(function() {
            var ref, currentPageNo, ref1, status, is_next_page;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        currentPageNo = pageNo.current[((ref = pageNo.current) === null || ref === void 0 ? void 0 : ref.length) - 1] + 1;
                        if (!(!loader.current && isNext.current && !initialPlpCall.current)) return [
                            3,
                            2
                        ];
                        loader.current = true;
                        return [
                            4,
                            (0,getFilteredOptionProducts/* getFilteredOptionsProducts */.H)(getSelectedFilters(), currentPageNo)
                        ];
                    case 1:
                        ref1 = _state.sent(), status = ref1.status, is_next_page = ref1.is_next_page;
                        if (status) {
                            pageNo.current.push(currentPageNo);
                            isNext.current = is_next_page;
                            if (!is_next_page) {
                                setIsFullItemsLoaded(true);
                            }
                        }
                        loader.current = false;
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return _loadMoreItems.apply(this, arguments);
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "SortAndFilteredItemsMid6",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                isLoaderVisible: false,
                isNext: true,
                onScrollEnd: function() {
                    return loadMoreItems();
                },
                renderInsideFragment: true,
                // add LoaderComponent for loading sections
                renderList: function() {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
                        productList: returnFilterItemsData(),
                        oldCardConfigs: {
                            showButton: true,
                            noTagsReadState: "fromLength"
                        }
                    });
                }
            }),
            loader.current && isNext.current && !isFullItemsLoaded && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex justify-center mt4 relative",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalCfeLoader/* GlobalCfeLoader */.I, {
                    type: (globalStyle === null || globalStyle === void 0 ? void 0 : (ref1 = globalStyle.appLoader) === null || ref1 === void 0 ? void 0 : ref1.loaderId) || "ellipsis",
                    color: globalStyle === null || globalStyle === void 0 ? void 0 : (ref2 = globalStyle.appLoader) === null || ref2 === void 0 ? void 0 : ref2.color
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody5/utils/useGetAnimationTranslation.js
var useGetAnimationTranslation = __webpack_require__(64604);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/CategoryItems.tsx




var CategoryItems = function(param) {
    var category = param.category;
    var ref = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalogData: state.catalogReducer
        };
    }), catalog_items = ref.catalogData.catalog_items;
    var returnCategoryData = function(categoryId) {
        return catalog_items[categoryId];
    };
    var categoryData = returnCategoryData(category === null || category === void 0 ? void 0 : category.id);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductListWrapper/* ProductListWrapper */.X, {
        productList: categoryData,
        oldCardConfigs: {
            showButton: true,
            noTags: category.hasOwnProperty("is_custom_tag")
        }
    });
};
/* harmony default export */ var MiddleBody6_CategoryItems = (CategoryItems);

// EXTERNAL MODULE: ./src/containers/Home/hooks/useScrollAnchor.ts
var useScrollAnchor = __webpack_require__(62769);
// EXTERNAL MODULE: ./src/utils/checkRenderEnv.js
var checkRenderEnv = __webpack_require__(6337);
// EXTERNAL MODULE: ./src/utils/scrollOnPageLoad.js
var scrollOnPageLoad = __webpack_require__(87243);
// EXTERNAL MODULE: ./src/utils/checkIfShowDummyProducts.js
var checkIfShowDummyProducts = __webpack_require__(20949);
// EXTERNAL MODULE: ./src/utils/checkIfThemePreview.js
var checkIfThemePreview = __webpack_require__(15483);
// EXTERNAL MODULE: ./src/components/CouponsAndVouchers/PromoSlider/index.tsx + 4 modules
var PromoSlider = __webpack_require__(71957);
// EXTERNAL MODULE: ./src/constants/promos.js
var promos = __webpack_require__(10445);
// EXTERNAL MODULE: ./src/utils/Widget2.0BuilderUtils.tsx
var Widget2_0BuilderUtils = __webpack_require__(46788);
// EXTERNAL MODULE: ./src/utils/removeEmojis.ts
var removeEmojis = __webpack_require__(51389);
;// CONCATENATED MODULE: ./src/components/DesignSystem/MiddleBody/MiddleBody6/index.js




























var HybridListing = function(props) {
    var handleShowFilterDrawer = function handleShowFilterDrawer(e) {
        e === null || e === void 0 ? void 0 : e.stopPropagation();
        setShowFilterDrawer(!showFilterDrawer);
    };
    var ref, ref1, ref2;
    var router = (0,next_router.useRouter)();
    var dispatch = (0,es/* useDispatch */.I0)();
    var ref3 = (0,react.useState)(false), showCategoryModal = ref3[0], setShowCategoryModal = ref3[1];
    var ref4 = (0,react.useState)(null), showFilterDrawer = ref4[0], setShowFilterDrawer = ref4[1];
    var filterDrawerWrapperRef = (0,react.useRef)();
    var categoryIdsFetched = (0,react.useRef)({});
    var ref5 = (0,useGetAnimationTranslation/* default */.Z)(showFilterDrawer), translationDistanceForAnimation = ref5.translationDistanceForAnimation, middleBodyContainerRef = ref5.middleBodyContainerRef;
    var ContainerHOC = (0,Widget2_0BuilderUtils/* useProductListParentForBuilderHOC */.i)(Hybrid_styles/* Container */.W2);
    var ref6 = (0,es/* useSelector */.v9)(function(state) {
        return {
            catalogData: state.catalogReducer,
            commonData: state.commonReducer,
            sortType: state.catalogReducer.sortType,
            filterAppliedCounter: state.catalogReducer.filterAppliedCounter
        };
    }), _catalogData = ref6.catalogData, categories = _catalogData.categories, catalog_items = _catalogData.catalog_items, productTags = _catalogData.productTags, _commonData = ref6.commonData, heroBannerHeightCalculated = _commonData.heightCalculation.heroBannerHeightCalculated, sortType = ref6.sortType, filterAppliedCounter = ref6.filterAppliedCounter;
    var storeData = (0,ssrStore/* useSSRSelector */.kF)(function(state) {
        return {
            storeData: state.storeReducer.store
        };
    }).storeData;
    var theme = storeData.theme, store_id = storeData.store_id, premium = storeData.premium;
    var shouldScrollToClickedItem = !checkRenderEnv/* IS_SERVER */.W6 && (0,scrollOnPageLoad/* scrollOnPageLoad */.l)().toScroll;
    var showDummyData = (0,checkIfShowDummyProducts/* default */.Z)(storeData);
    var isPreview = (0,checkIfThemePreview/* default */.Z)();
    var isTag = function(categoryId) {
        return (productTags === null || productTags === void 0 ? void 0 : productTags.length) && productTags.findIndex(function(tag) {
            return tag.id === categoryId;
        }) >= 0;
    };
    (0,react.useEffect)(function() {
        if (shouldScrollToClickedItem) {
            (0,useScrollAnchor/* persistScrollPosition */.V)();
        } else {
            !showDummyData && dispatch((0,catalog/* resetCatalogItems */.wo)());
        }
    }, []);
    (0,react.useEffect)(function() {
        var ref;
        // don't scroll to category when we have scroll position
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid) && !shouldScrollToClickedItem) {
            var ref1;
            (ref1 = document.getElementById("listing-".concat(router.query.cid))) === null || ref1 === void 0 ? void 0 : ref1.scrollIntoView();
        }
    }, [
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.cid,
        catalog_items
    ]);
    var toggleCategoryModal = function() {
        setShowCategoryModal(!showCategoryModal);
    };
    var returnCategoryData = function(categoryId) {
        return catalog_items[categoryId];
    };
    var loadMoreData = function(categoryId) {
        if (categoryIdsFetched.current[categoryId]) {
            return;
        }
        var payload = {
            store_id: store_id,
            category_id: categoryId,
            category_type: isTag(+categoryId) ? constants/* CATEGORY_TYPE.TAG */.MI.TAG : constants/* CATEGORY_TYPE.CATEGORY */.MI.CATEGORY,
            page_no: 0
        };
        dispatch((0,catalog/* fetchCatalogItemsByCategoryId */.Is)(payload));
        categoryIdsFetched.current[categoryId] = true;
    };
    var renderListing = function(item) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* ListingHeading */.E, {
                    id: "listing-".concat(item === null || item === void 0 ? void 0 : item.id),
                    children: (0,removeEmojis/* removeEmojisFromTagName */.U)(item === null || item === void 0 ? void 0 : item.name) || item.hasOwnProperty("is_custom_tag") || "Available Items"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "tw-p-[20px] md:tw-px-0 md:tw-pb-[24px] md:tw-pt-[10px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(PromoSlider/* default */.Z, {
                            type: isTag(item === null || item === void 0 ? void 0 : item.id) ? promos/* PROMO_APPLICABILITY_TYPES.TAG */.d.TAG : promos/* PROMO_APPLICABILITY_TYPES.CATEGORY */.d.CATEGORY,
                            typeId: item === null || item === void 0 ? void 0 : item.id,
                            customClasses: "md:tw-px-[32px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FlatList/* default */.Z, {
                            renderOnVisible: true,
                            renderInsideFragment: true,
                            isLoaderVisible: false,
                            isNext: showDummyData ? false : !returnCategoryData(item === null || item === void 0 ? void 0 : item.id),
                            onScrollEnd: function() {
                                return loadMoreData(item === null || item === void 0 ? void 0 : item.id);
                            },
                            renderList: function() {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(MiddleBody6_CategoryItems, {
                                    category: item
                                });
                            }
                        })
                    ]
                })
            ]
        }, item === null || item === void 0 ? void 0 : item.id);
    };
    var displayItems = function() {
        var ref;
        /** While displaying categories and product tags in Website Builder, there is a performance issue. The browser freezes, hence as a hack we are restricting display of total categories and items within them for now. This can be properly fixed by virtual list in near future. No impact on CFE as of now */ var itemsToDisplay = showDummyData ? categories : (0,_to_consumable_array/* default */.Z)(productTags).concat((0,_to_consumable_array/* default */.Z)(categories));
        var displayLimit = props.displayMiddleBodyInWebsiteBuilder ? 5 : undefined;
        /* although we don't need this filter as we will only have active tags, 
    but the tags are cached on client side (and some inactive tags may be there on client end)
    therefore, for the safe side we are keeping it for now and will remove this in future. */ var filteredItems = itemsToDisplay.filter(function(item) {
            return item.hasOwnProperty("is_active") ? item.is_active : true;
        });
        return (ref = filteredItems === null || filteredItems === void 0 ? void 0 : filteredItems.slice(0, displayLimit)) === null || ref === void 0 ? void 0 : ref.map(function(item) {
            return renderListing(item);
        });
    };
    return (0,conditionalForMiddlebodyRender/* conditionalForMiddlebodyRender */.Y)(heroBannerHeightCalculated, (theme === null || theme === void 0 ? void 0 : theme.theme_id) || (theme === null || theme === void 0 ? void 0 : theme.theme_id) === 0, router === null || router === void 0 ? void 0 : (ref1 = router.route) === null || ref1 === void 0 ? void 0 : ref1.includes("shop")) && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hybrid_styles/* MiddleBodyAdWrapper */.rV, {
            children: [
                props.sortAndFiltersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterDrawerMidd6, {
                    showFilterDrawer: showFilterDrawer,
                    handleShowFilterDrawer: handleShowFilterDrawer,
                    filterDrawerWrapperRef: filterDrawerWrapperRef,
                    hideCollectionFilter: true,
                    hideCategoryFilter: false,
                    hideTags: true
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContainerHOC, {
                    ref: middleBodyContainerRef,
                    trasnlationDist: translationDistanceForAnimation.current,
                    showFilterDrawer: showFilterDrawer,
                    children: [
                        router.route !== constants/* SHOP_DOMAIN_ROUTE */.L8 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* Heading */.X6, {
                            children: "Categories"
                        }),
                        props.sortAndFiltersEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortingAndFiltersTab/* default */.Z, {
                            middleBodyRef: middleBodyContainerRef,
                            showFilterDrawer: showFilterDrawer,
                            handleShowFilterDrawer: handleShowFilterDrawer,
                            filterDrawerWrapperRef: filterDrawerWrapperRef
                        }),
                        (!!sortType || !!filterAppliedCounter) && props.sortAndFiltersEnabled ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FilteredAndSortItems, {}) : displayItems(),
                        (theme === null || theme === void 0 ? void 0 : theme.colors) && !showCategoryModal && (categories === null || categories === void 0 ? void 0 : categories.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* AllCategorySection */.Z5, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hybrid_styles/* AllCategoryButton */.bu, {
                                backgroundColor: premium ? theme === null || theme === void 0 ? void 0 : (ref2 = theme.colors) === null || ref2 === void 0 ? void 0 : ref2.primary_color : "#000000",
                                onClick: toggleCategoryModal,
                                children: "All Categories"
                            })
                        })
                    ]
                }),
                showCategoryModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryModal, {
                    toggleModal: toggleCategoryModal,
                    isVisible: showCategoryModal
                }),
                !isPreview && /*#__PURE__*/ (0,jsx_runtime.jsx)(DesktopDsAds/* default */.Z, {
                    mr: "mr40px",
                    pt: "pt40px",
                    mb: "digital-showroom__ads__mb15rem",
                    ml: "",
                    id: "DesktopDsAds-1"
                })
            ]
        })
    });
};
/* harmony default export */ var MiddleBody6 = (HybridListing);


/***/ }),

/***/ 62769:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ persistScrollPosition; },
/* harmony export */   "l": function() { return /* binding */ useScrollAnchor; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13886);
/* harmony import */ var _utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87243);



function persistScrollPosition() {
    var scrollConfig = (0,_utils_scrollOnPageLoad__WEBPACK_IMPORTED_MODULE_2__/* .scrollOnPageLoad */ .l)();
    if (!scrollConfig.toScroll) {
        return;
    }
    var x_scroll = scrollConfig.x_scroll, y_scroll = scrollConfig.y_scroll;
    setTimeout(function() {
        window.scrollTo(x_scroll, y_scroll);
        sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
    }, 300);
}
function useScrollAnchor() {
    var isPageRefreshed = // Check was it refreshed/reloaded using the browser's reload button
    function isPageRefreshed() {
        var ref, ref1;
        var performance = window.performance;
        if (!performance) {
            return false;
        }
        return performance.navigation && performance.navigation.type === 1 || performance.getEntriesByType("navigation").map(function(nav) {
            return nav.type;
        }).includes("reload") || (performance === null || performance === void 0 ? void 0 : (ref = performance.navigation) === null || ref === void 0 ? void 0 : ref.type) == (performance === null || performance === void 0 ? void 0 : (ref1 = performance.navigation) === null || ref1 === void 0 ? void 0 : ref1.TYPE_RELOAD);
    };
    var resetScrollPosition = function resetScrollPosition() {
        setTimeout(function() {
            sessionStorage.removeItem(_utils_constants__WEBPACK_IMPORTED_MODULE_1__/* .CLICKED_ITEM_OBJ */ .uI);
            window.scrollTo(0, 0);
        }, 300);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var wasPageRefreshed = isPageRefreshed();
        if (!wasPageRefreshed) persistScrollPosition();
        else resetScrollPosition();
    }, []);
    return null;
}


/***/ }),

/***/ 20949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(15483);
/* harmony import */ var _checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6337);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13886);
/* harmony import */ var _getUrlParams__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5492);




var checkIfShowDummyProduts = function(storeData) {
    var isPreview = (0,_checkIfThemePreview__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)();
    var isPremium = !!storeData.premium;
    var items_available = (!_checkRenderEnv__WEBPACK_IMPORTED_MODULE_1__/* .IS_SERVER */ .W6 && (0,_getUrlParams__WEBPACK_IMPORTED_MODULE_3__/* .getUrlParams */ .D)([
        _constants__WEBPACK_IMPORTED_MODULE_2__/* .PREVIEW_PARAMS.ITEMS_AVAILABLE */ .I.ITEMS_AVAILABLE
    ])).items_available;
    var isItemsAvailable = +items_available;
    return isPreview && (!isPremium || !isItemsAvailable);
};
/* harmony default export */ __webpack_exports__["Z"] = (checkIfShowDummyProduts);


/***/ }),

/***/ 86423:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ isPLPRequiredSystem; }
/* harmony export */ });
var isPLPRequiredSystem = function(themeVar) {
    switch(themeVar){
        case 1:
            return true;
        case 2:
            return true;
        case 3:
            return false;
        case 4:
            return false;
        default:
            return true;
    }
};


/***/ }),

/***/ 51389:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ removeEmojisFromTagName; }
/* harmony export */ });
function removeEmojisFromTagName() {
    var stringer = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var ref;
    var emojiRegex1 = RegExp("\\p{Emoji}", "u");
    var emojiRegex2 = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
    var tagClean1 = stringer === null || stringer === void 0 ? void 0 : stringer.replace(emojiRegex2, "");
    var isEmoji = emojiRegex1.test(tagClean1 === null || tagClean1 === void 0 ? void 0 : tagClean1[0]);
    return isEmoji ? (ref = tagClean1 === null || tagClean1 === void 0 ? void 0 : tagClean1.substring(1)) === null || ref === void 0 ? void 0 : ref.trim() : tagClean1 === null || tagClean1 === void 0 ? void 0 : tagClean1.trim();
}


/***/ }),

/***/ 28279:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 52951:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _createClass; }
/* harmony export */ });
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}


/***/ })

}]);